import type React from 'react';
import { forwardRef } from 'react';

export type AddressDropdownItemProps = {
  ariaSelected: boolean;
  disableHoverStyles: boolean;
  highlighted: boolean;
  id?: string;
  onClick: (event: React.MouseEvent<HTMLLIElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLLIElement>) => void;
  onMouseMove: (event: React.MouseEvent<HTMLLIElement>) => void;
  subtitle: string;
  title: string;
};

const AddressDropdownItem = forwardRef<HTMLLIElement, AddressDropdownItemProps>(
  (
    {
      ariaSelected,
      disableHoverStyles,
      highlighted,
      id,
      onClick,
      onKeyDown,
      onMouseMove,
      subtitle,
      title,
    }: AddressDropdownItemProps,
    ref,
  ) => (
    // biome-ignore lint/a11y/useFocusableInteractive: the combobox input owns keyboard focus
    <li
      className="fp-dropdown-item cursor-pointer mb-1 py-1 px-4 [&>p:first-child]:mb-1"
      data-dd-privacy="mask"
      aria-selected={ariaSelected}
      data-disable-hover-styles={disableHoverStyles}
      data-highlighted={highlighted}
      id={id}
      onClick={onClick}
      onKeyDown={onKeyDown}
      onMouseMove={onMouseMove}
      ref={ref}
      // biome-ignore lint/a11y/noNoninteractiveElementToInteractiveRole: Downshift listbox option
      role="option"
    >
      <div className="fp-dropdown-item-title text-body-2 mb-1">{title}</div>
      <div className="fp-dropdown-item-secondary text-body-2">{subtitle}</div>
    </li>
  ),
);

export default AddressDropdownItem;
